import { useDispatch, useSelector } from 'react-redux';
import { useAccount } from 'wagmi';
import { ILeaderboard } from '@kattana-io/common';
import {
  IMobileTableScema,
  formatMobileTableData,
} from '../../../../helpers/formatters';
import TableCardMobile from '../../../../molecules/Table/mobile/TableCard';
import { decorateLeaderboardTableData } from '.';
import { IStore } from '../../../../reducers';
import { actionSetCompetitionWallet } from '../../../../actions/competition';
import TableHeaderMobile from '../../../../molecules/Table/mobile/TableHeader';

interface ILeaderboardTableMobileProps {
  tableData: ILeaderboard[];
}

const LeaderboardTableMobile = ({
  tableData,
}: ILeaderboardTableMobileProps) => {
  const active = useSelector((state: IStore) => state.competition.wallet);

  const { address } = useAccount();
  const dispatch = useDispatch();

  const schema: IMobileTableScema = {
    row_1: {
      item_1: {
        name: 'Nickname',
        accessor: 'Nickname',
        parser: (value) => value.formatted,
        width: 150,
      },
      item_2: {
        name: 'Points',
        accessor: 'Points',
        parser: (value) => value.formatted,
      },
    },
    row_2: {
      item_1: {
        name: 'Fav. Pair',
        accessor: 'Fav. Pair',
        parser: (value) => value.formatted,
        width: 150,
      },
      item_2: {
        name: '#',
        accessor: '#',
        parser: (value) => value.formatted,
      },
    },
    row_3: {
      item_1: {
        name: 'Potential reward',
        accessor: 'Potential reward',
        parser: (value) => value.formatted,
        width: 150,
      },
    },
  };

  const activeUser = active || address;

  const handleCardClick = (row: any) => {
    const wallet = row.Nickname.raw;
    if (wallet === activeUser) {
      return;
    }
    if (wallet === address) {
      dispatch(actionSetCompetitionWallet(undefined));
    } else {
      dispatch(actionSetCompetitionWallet(wallet));
    }
  };

  return (
    <div className='dex_trades_mobile__table'>
      {!tableData.length ? (
        <div className='centrify'>No data found</div>
      ) : (
        <>
          <TableHeaderMobile schema={schema} />
          {formatMobileTableData({
            data: decorateLeaderboardTableData(tableData),
            schema,
            getColorForItem: () => 'grey',
            handleCardClick,
          })?.map((row, index) => (
            <TableCardMobile key={index} data={row} />
          ))}
        </>
      )}
    </div>
  );
};

export default LeaderboardTableMobile;
